<template></template>

<script setup>
import { onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'

import { mainStore } from '../store'

import request from '../common/request'
import authService from '../services/auth.service'

const store = mainStore()
const router = useRouter()

const user = computed(() => store.user)

async function redirect() {
    try {
        await request.fetch({ collection: 'users', attr: 'user' })

        console.log(user.value)

        authService.saveOnLocalStorage('image', user.value.image)
        authService.saveOnLocalStorage('id', user.value._id)

        router.push({ name: 'dashboard' })
    } catch (error) {
        console.error(error)
    }
}

onMounted(() => redirect())
</script>
